import { render, staticRenderFns } from "./FlatGuestBox.vue?vue&type=template&id=2249a31a&scoped=true&"
import script from "./FlatGuestBox.vue?vue&type=script&lang=js&"
export * from "./FlatGuestBox.vue?vue&type=script&lang=js&"
import style0 from "./FlatGuestBox.vue?vue&type=style&index=0&id=2249a31a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2249a31a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2249a31a')) {
      api.createRecord('2249a31a', component.options)
    } else {
      api.reload('2249a31a', component.options)
    }
    module.hot.accept("./FlatGuestBox.vue?vue&type=template&id=2249a31a&scoped=true&", function () {
      api.rerender('2249a31a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21eRndjzuZDgx/JS/comp/FlatGuestBox.vue"
export default component.exports